<template :key="new Date().getTime() + loggedIn">
  <div>
    <page :key="loggedIn">
      <template :slot="'title'">
        Online <md-icon>videocam</md-icon> /
        <md-icon>mic</md-icon> Recorder</template
      >
      <template :slot="'content'">
        <myPassword v-if="!loggedIn" :password="'test'" :onSuccess="setLogin"
          >System-Passwort</myPassword
        >
        <settings v-else />
      </template>
    </page>
  </div>
</template>
<script>
export default {
  components: {
    page() {
      return import("@/components/page/");
    },
    myPassword() {
      return import("@/components/password/");
    },
    settings() {
      return import("@/components/settings/");
    }
  },
  props: {},
  data() {
    return {
      loggedIn: false
    };
  },
  methods: {
    setLogin() {
      this.loggedIn = true;
    }
  },
  mounted() {},
  computed: {}
};
</script>
<style lang="sass" scoped></style>
